import { Component, OnInit } from '@angular/core';
import { UserService } from '../Services/user.service';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StoreService } from '../Services/store.service';
@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [HttpClientModule, CommonModule, RouterLink],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  providers: [UserService,StoreService],
})
export class NavbarComponent implements OnInit {
  isLoggedIn: boolean = false;
  userRole: string = '';
  storeName: string = ''; 
  showLoginButton = true;
  constructor(private router: Router, private userService: UserService,private storeService: StoreService) {}

  ngOnInit(): void {
    this.updateLoginStatus();
    console.log("Current role- ", this.userRole);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateLoginStatus();
      });
    this.router.events.subscribe(event=>{
      if(event instanceof NavigationEnd){
        const currentRoute = event.urlAfterRedirects;
        if(currentRoute == '/login'){
          this.showLoginButton = false;
        }else{
          this.showLoginButton = true;
        }
      }
    });
  }

  updateLoginStatus(): void {
    this.isLoggedIn = !!this.userService.getToken();
    this.userRole = this.userService.checkRole() ?? '';
    if (this.isLoggedIn && (this.userRole === 'StoreAdmin' || this.userRole === 'StoreUser')) {
    this.getStore();   
  } else {
    this.storeName = '';  
  }
  }

  logout(): void {
    this.userService.removeToken();
    this.storeName='';
    this.updateLoginStatus();
    this.router.navigate(['/login']);
  }

  getStore() : void{
    const storeId = this.userService.getStoreId();
    if (storeId && (this.userRole === 'StoreAdmin' || this.userRole === 'StoreUser')) {
      this.storeService.getStoreById(storeId).subscribe({
        next: (store: any) => {
          console.log("storedetails",store.result?.name);
          this.storeName = store.result?.name ?? 'Store';
        },
        error: (err) => {
          console.error('Error fetching store info:', err);
        },
      });
    }
  }
}
